import { generateTypes } from '../../utils/HttpReducerHelper';

const benchmarkScore = generateTypes('MONITOR', 'BENCHMARK_SCORE');

export { benchmarkScore };
